import React from "react";
import CheckBox from "@components/checkBox";
import Wrapper from "./consentCheckbox.styles";
import { ExternalLink } from '@components/externalLink'
import { useFormikContext } from "formik";
import { useSetDefaultValue } from "@hooks";
import environmentSettings from "../../../../constants/environmentSettings";

const name = "accessSeekerConsent";

export default function VehicleConsentCheckbox({ ...props }) {
  const { handleChange, handleBlur, values, errors, touched } = useFormikContext();
  useSetDefaultValue(name, false);

  return (
    <Wrapper>
      <label>
        <CheckBox
          id={name}
          name={name}
          checked={values[name]}
          onChange={handleChange}
          onBlur={handleBlur}
          errorMessage={touched[name] ? errors[name] : ""}
        >
          For the purposes of a preliminary assessment I agree to the terms of  
          {" "}
          <ExternalLink 
            href= {environmentSettings.privacyPolicyPageFSA}
            target="_blank" 
            rel="noopener noreferrer">
              the Privacy Policy
          </ExternalLink>
          {" "}
              which includes the permission for Fintech Services (Aust) Pty Ltd to:
          <ul>
            <li>collect personal information about my identity and contact details in order to obtain my credit score from a Credit Reporting Body;</li>
            <li>using my credit score to assess whether I am suitable on a preliminary basis only, to refer me to either a Credit Provider (a lender) or a Credit Assistance Provider (a broker).</li>
          </ul>
        </CheckBox>
      </label>
    </Wrapper>
  );
}
